import React, { useState } from 'react'
import { useDispatch, shallowEqual, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { Typography } from '@mui/material'
import IconButton from '@mui/material/IconButton'
import FilterListIcon from '@mui/icons-material/FilterList'
import Search from '../../../components/Search'
import { StyledListHeader, StyledRightFlex } from './Styled'
import { isMediaWidthMoreThan } from 'src/utils/lib'
import { setFilterValue } from 'src/redux/slices/eContent'
import FilterDrawer from '../Filter/FilterDrawer'

const ListHeader = ({ hasFilter = false }) => {
  const dispatch = useDispatch()
  const history = useHistory()
  const [isOpen, setOpen] = useState(false)
  const isNotSm = isMediaWidthMoreThan('sm')
  const { keyword, type } = useSelector(
    (state) => ({
      keyword: state.eContent.keyword,
      type: state.eContent.filter.type,
    }),
    shallowEqual
  )

  return (
    <>
      <StyledListHeader>
        <Typography sx={{ minWidth: 112 }} variant={isNotSm ? 'h4' : 'h5'}>
          คลังความรู้
        </Typography>
        <StyledRightFlex>
          <Search
            boxSx={{ width: isNotSm ? 227 : 180 }}
            placeholder="ค้นหา"
            text={keyword}
            setText={(value) =>
              dispatch(setFilterValue({ key: 'keyword', value: value }))
            }
            handleSearch={() => history.push(`/e-content/search`)}
          />
          {hasFilter && (
            <IconButton
              id="btn-filter"
              data-testid="btn-filter"
              size="small"
              color="primary"
              sx={{ position: 'relative' }}
              onClick={() => setOpen(true)}
            >
              <FilterListIcon />
            </IconButton>
          )}
        </StyledRightFlex>
        <FilterDrawer isOpen={isOpen} setOpen={setOpen} type={type} />
      </StyledListHeader>
    </>
  )
}
export default ListHeader
